import { Helmet } from "react-helmet";
import styled from "styled-components";
import HeroSection from "./HeroSection";
import ShortAbout from "./ShortAbout";
import ExploreEquipments from "./ExploreEquipments";
import FamilyBusiness from "./FamilyBusiness";

const Landing = () => {
  return (
    <>
      <Helmet>
        <title>AgroHarvest | Home</title>
        <meta
          name="description"
          content="AgroHarvest offers comprehensive agricultural machinery design services with expertise in sustainable solutions, precision farming technologies, and regulatory compliance."
        />
      </Helmet>
      <LandingLayout>
        <HeroSection />
        <ShortAbout />
        <ExploreEquipments />
        <FamilyBusiness/>
      </LandingLayout>
    </>
  );
};
const LandingLayout = styled.div``;
export default Landing;
